<template>
  <div id="Caseapprove">
    <!-- 加载中组件 -->
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="search">
      <el-form ref="form" :model="form" label-width="90px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="案件名称">
              <el-input
                v-model="form.name"
                prefix-icon="el-icon-search"
                placeholder="请输入要查找的案件名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="案件类型">
              <el-select
                v-model="form.type"
                placeholder="请选择"
                class="select"
                clearable
              >
                <el-option
                  v-for="item in Casetype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="案件状态">
              <el-select
                v-model="form.status"
                placeholder="请选择"
                class="select"
                disabled
              >
                <el-option
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="开始时间">
              <el-date-picker
                class="select"
                v-model="form.starttime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束时间">
              <el-date-picker
                class="select"
                v-model="form.endtime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button type="primary" @click="SearchBtn">搜索</el-button>
              <el-button @click="reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="code" label="案件编号"> </el-table-column>
        <el-table-column prop="title" label="案件名称"> </el-table-column>
        <el-table-column prop="type" label="案件类型" width="120">
        </el-table-column>
        <el-table-column prop="lawyer" label="承办律师"> </el-table-column>
        <el-table-column prop="approve" label="审核人"> </el-table-column>
        <el-table-column prop="entrustmentTime" label="提交时间" width="100">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="staus">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" type="text" class="casestatus"
              >待审核</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="210">
          <template slot-scope="scope">
            <el-button
              class="tg"
              size="small"
              @click="approval(scope.row.id, 0)"
              v-if="$store.state.rolesname.includes('Caseapprove_pass')"
              >通过</el-button
            >
            <el-button
              class="tjtg"
              size="small"
              @click="approvalReason(scope.row.id)"
              v-if="$store.state.rolesname.includes('Caseapprove_pass')"
              >有条件通过</el-button
            >
            <el-button
              class="bh"
              size="small"
              @click="approval(scope.row.id, 1)"
              v-if="$store.state.rolesname.includes('Caseapprove_refuse')"
              >驳回</el-button
            >
            <el-button class="look" size="small" @click="Look(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="bank_pagination">
        <el-pagination
          :hide-on-single-page="value"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-if="bPageShow"
        />
      </div>
    </div>

    <!--更多选择!-->
    <el-dialog
      title="搜索"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
    >
    </el-dialog>

    <!-- 有条件通过 -->
    <el-dialog
      :title="title"
      :visible.sync="tjSuccessdialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="successform"
          label-width="80px"
          ref="successformref"
          :rules="successformrules"
        >
          <el-form-item prop="Reason" label="通过条件" v-if="isTj">
            <el-input
              v-model="successform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
          <el-form-item prop="RemarkApproval" label="备注" v-else>
            <el-input
              v-model="successform.RemarkApproval"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div
          class="refuse"
          v-if="$store.state.rolesname.includes('Caseapprove_refuse')"
        >
          <el-button  v-if="isTj" @click="SuccessTJ('successformref')" type="primary"
            >有条件通过</el-button
          >
          <el-button  v-else @click="SuccessTJ('successformref')" type="primary"
            >通过</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 驳回 -->
    <el-dialog
      :title="title"
      :visible.sync="approvaldialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="failform"
          label-width="80px"
          ref="failformref"
          :rules="failformrules"
        >
          <el-form-item prop="Reason" label="驳回原因">
            <el-input
              v-model="failform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div
          class="refuse"
          v-if="$store.state.rolesname.includes('Caseapprove_refuse')"
        >
          <el-button @click="refuse('failformref')" type="primary"
            >驳回</el-button
          >
        </div>
      </div>
      <div class="success" v-else>
        <div><img src="../../assets/success.svg" /></div>
        <div class="pass">已通过</div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { CaseType, Case, Reject, Success } from '../../api/examine'

var reason = (rule, value, callback) => {
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (value.match(/^[ ]*$/)) {
      callback(new Error('驳回原因不能为空'))
    }
  }
  callback()
}
export default {
  name: 'Caseapprove',
  // components:{
  //   Table
  // },
  data() {
    return {
      isLoading: false,
      bPageShow: true,
      more: '',
      dialogVisible: false,
      form: {
        name: '',
        status: 1,
        starttime: null,
        endtime: null,
        type: null,
        invoice: null,
        closecase: null,
        file: null
      },
      Status: [
        { label: '已通过', value: 0 },
        { label: '待审核', value: 1 },
        { label: '未通过', value: 3 },
        { label: '已删除', value: -1 }
      ],
      dialogVisible: false, //弹出框
      IsorNo: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      Casetype: [],
      tableData: [],
      PageSizes: [10, 20, 50, 100],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      value: false, //只有一页的时候隐藏分页
      //审核弹出框
      approvaldialog: false,
      title: '',
      failformrules: {
        Reason: [
          { required: true, message: '驳回原因不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      },
      successformrules: {
        Reason: [
          { required: true, message: '通过条件不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      },
      failform: {
        id: '',
        Reason: ''
      },
      tjSuccessdialog: false,
      successform: {
        id: '',
        Reason: '',
        RemarkApproval:'',
      },
      isTj:false,//是否是条件通过
    }
  },
  mounted() {},
  methods: {
    Search() {
      var starttime = null
      var endtime = null
      if (this.form.starttime) {
        starttime = this.JsonTime(this.form.starttime)
      }
      if (this.form.endtime) {
        endtime = this.JsonTime(this.form.endtime)
      }
      this.isLoading = true
      Case({
        page: this.PageIndex,
        rows: this.PageSize,
        Title: this.form.name,
        Status: this.form.status,
        StartTime: starttime,
        EndTime: endtime,
        Type: this.form.type,
        Invoice: this.form.invoice,
        Closecase: this.form.closecase,
        IsorNo: this.form.isorNo
      }).then((res) => {
        if (res.data.status == 'success') {
          this.tableData = res.data.data
          this.Total = res.data.total
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error('获取失败')
        }
        this.dialogVisible = false
        this.isLoading = false
      })
    },
    GetType() {
      //案件类型
      CaseType().then((res) => {
        if (res.data.status == 'success') {
          this.Casetype = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error('获取失败')
        }
      })
    },
    reset() {
      //重置更多选择
      this.form.name = ''
      ;(this.form.status = 1), (this.form.starttime = null)
      this.form.endtime = null
      this.form.invoice = null
      this.form.closecase = null
      this.form.isorNo = null
      this.form.type = null
      this.SearchBtn()
    },
    SearchBtn() {
      //查询按钮
      this.PageIndex = 1
      this.Search()
    },
    handleCancle() {
      if (this.title == '通过条件') {
        this.$refs.successformref.resetFields()
      } else if (this.title == '驳回原因') {
        this.$refs.failformref.resetFields()
      }
    },
    approvalReason(id) {
      this.title = '通过条件'
      this.successform.id = id
      this.tjSuccessdialog = true
      this.isTj=true
    },
    approval(id, type) {
      //审核
      var header = document.getElementsByClassName('el-dialog__header')
      if (type == 0) {
        // this.title = '备注'
        // this.successform.id = id
        // this.tjSuccessdialog = true
        // this.isTj=false
        //通过
        this.isLoading = true
        Success({ Id: id }).then((res) => {
          if (res.data.status == 'success') {
            this.title = ''
            header[1].style.display = 'none'
            this.approvaldialog = true
            this.Search()
            if (this.approvaldialog) {
              setTimeout(() => {
                this.approvaldialog = false
              }, 2000)
            }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      
      }
      if (type == 1) {
        //驳回
        this.title = '驳回原因'
        header[1].style.display = ''
        this.approvaldialog = true
        this.failform.id = id
      }
    },
    refuse(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          Reject({ Id: this.failform.id, Reason: this.failform.Reason }).then(
            (res) => {
              if (res.data.status == 'success') {
                this.$message.success('审核成功')
                this.Search()
              } else if (
                res.data.status == '401' ||
                res.data.status == '402' ||
                res.data.status == '403'
              ) {
                this.$message.error(res.data.message)
                window.sessionStorage.removeItem('token')
                window.sessionStorage.removeItem('hasRoles')
                this.$router.push('/login')
              } else {
                this.$message.error(res.data.message)
              }
            }
          )
          this.approvaldialog = false
          this.isLoading = false
          // console.log(this.failform.id)
        } else {
          this.$message.error('有必填项为空！')
          return false
        }
      })
    },

    //有条件通过确定
    SuccessTJ(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          Success({
            Id: this.successform.id,
            Reason: this.successform.Reason,
            RemarkApproval:this.successform.RemarkApproval,
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('审核成功')
              this.Search()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
          })
          this.tjSuccessdialog = false
          this.isLoading = false
        } else {
          this.$message.error('有必填项为空！')
          return false
        }
      })
    },
    Look(row) {
      //查看
      this.$router.push({
        path: '/home/examine/Casedetail',
        query: {
          guid: row.id,
          type: row.type
        }
      })
    },
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogVisible = true
    },
    handleSizeChange(val) {
      //条数变化
      this.pageSize = val
      this.Search()
    },
    handleCurrentChange(val) {
      this.$store.commit('setPage', val)
      //页数变化
      this.PageIndex = val
      this.Search()
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    // --时间格式转换--
    formatTime(row) {
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      if (hours == '00' && minutes == '00' && seconds == '00') {
        return year + '-' + month + '-' + day
      } else {
        return (
          year + '-' + month + '-' + day
          // +
          // ' ' +
          // hours +
          // ':' +
          // minutes +
          // ':' +
          // seconds
        )
      }
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    }
  },
  created() {
    this.GetType()
  },
  beforeRouteLeave(to, from, next) {
    const type = 'examninePage'
    if (to.name == 'Casedetail') {
      var con = {
        form: this.form,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      }
      this.$store.dispatch('saveSearchCondition', { type, condition: con }) //保存
    } else {
      this.$store.dispatch('clearSearchConditions', type) //保存
    }

    next()
  },
  beforeRouteEnter(to, from, next) {
    // 辅助函数，用于在组件实例化之前执行一些代码
    function fetchData() {
      const type = 'examninePage'
      // console.log("获取")
      // 从 Vuex store 中读取搜索条件
      if (this.$store.state.searchConditions[type]) {
        return this.$store.state.searchConditions[type]
      }
      return null
    }
    // 通过 next 回调访问组件实例
    next((vm) => {
      const fetchedData = fetchData.call(vm)
      if (fetchedData && from.name == 'Casedetail') {
        vm.form = fetchedData.form
        vm.PageIndex = fetchedData.PageIndex
        vm.PageSize = fetchedData.PageSize
        // console.log(fetchedData.PageIndex)
        vm.bPageShow = false
        vm.$nextTick(() => {
          vm.bPageShow = true
        })
        vm.Search()
      } else {
        vm.Search()
      }
    })
  }
}
</script>
  
<style lang="less" scoped>
// 查询
#Caseapprove .search {
  box-sizing: border-box;
  width: 100%;
  // margin: auto;
  // display: flex;

  padding: 20px;
  // margin-bottom: 24px;
}

#Caseapprove .search ::v-deep .el-input__inner {
  // width: 80% !important;
  // width: 300px;
  background-color: #fafafa;
  border: 0 !important;
  border-radius: 12px;
}

#Caseapprove .nameSearch {
  width: 24vw;
  margin-right: 10px;
}

// #Caseapprove .select {
//   width: 10vw;
//   margin-right: 10px;
// }

// 弹出框
#Caseapprove /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#Caseapprove .success {
  width: 100%;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
}

#Caseapprove .pass {
  color: #718096;
  font-size: 24px;
  margin-top: 12px;
}

#Caseapprove .fail {
  width: 100%;
}

#Caseapprove .refuse {
  width: 100%;
  text-align: center;
}

//表格
#Caseapprove .casestatus {
  color: rgba(254, 150, 74, 1);
}

#Caseapprove .btn {
  width: 100%;
  text-align: center;
}

#Caseapprove .tg {
  background: #e7f7ef;
  border-radius: 8px;
  color: #0caf60;
  border: none;
}
#Caseapprove .tjtg {
  background: #f5f7e7;
  border-radius: 8px;
  color: #cfb522;
  border: none;
}
#Caseapprove .bh {
  background: #fff0e6;
  border-radius: 8px;
  color: #fe964a;
  border: none;
}

#Caseapprove .look {
  background: #eff5ff;
  border-radius: 8px;
  color: #3077e6;
  border: none;
}

// 分页
#Caseapprove .bank_pagination {
  text-align: right;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

#Caseapprove /deep/.el-pagination__total {
  float: left;
}

#Caseapprove /deep/.el-pagination__sizes {
  float: left;
}
</style>
  